export const locale = {
  rtl: true,
  convertToDate: (y: any, m: any, d: any): [any, any, any] => [y, m, d],
  daysOfEachMonth: (y: any, m: any) => {
    switch (m) {
      case 1:
      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 10:
      case 12:
        return 31;
      case 2:
        let isKabise = false;
        if (y % 400 === 0) isKabise = true;
        else if (y % 100 === 0) isKabise = false;
        else if (y % 4 === 0) isKabise = true;
        return isKabise ? 29 : 28;
      default:
        return 30;
    }
  },
  name: "en-US",
  numberConverter: (n: any) => parseInt(n),
  startOfWeek: 0,
  title: "",
  todayButtonText: "",
};

export const productionCheck = process.env.REACT_APP_ENV === "prod";

export const getObjectKey = (path?: string) => {
  if (!path) return undefined;
  return path.replace(/^(noc-document|morth-documents)\/(row|access)\//, "");
};
